import React from "react";
import { Box, Typography } from "@mui/material";
import { MessageTooltipIcon, PoweredByTrustChatIcon } from "../widgetPreviewIcons";
import { COLORS, FONT } from "../../../shared/styles";
import WidgetInputBar from "./WidgetInputBar";
import WidgetFab from "./WidgetFab";
import widgetAvatar from "../../../../../../assets/images/widget-avatar.png";

const AGENT_AVATAR = widgetAvatar;

const LONG_REPLY =
  "Hey Olivia, Katherine sent me the latest doc — quick question about it...";

function Avatar() {
  return (
    <Box
      sx={{
        width: 28,
        height: 28,
        borderRadius: "50%",
        flexShrink: 0,
        backgroundImage: `url(${AGENT_AVATAR})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#E5E9EC",
      }}
    />
  );
}

function Timestamp({ children, align = "left" }) {
  return (
    <Typography
      sx={{
        mt: "4px",
        fontSize: "11px",
        fontFamily: FONT.family,
        color: COLORS.textSecondary,
        textAlign: align,
      }}
    >
      {children}
    </Typography>
  );
}

function IncomingMessage({ children }) {
  return (
    <Box
      sx={{
        alignSelf: "flex-start",
        maxWidth: "78%",
        px: "12px",
        py: "8px",
        borderRadius: "1px 16px 16px 16px",
        background: "rgba(241, 243, 245, 0.80)",
        backdropFilter: "blur(5px)",
        color: COLORS.textPrimary,
        fontFamily: FONT.family,
        fontSize: "14px",
        lineHeight: "20px",
      }}
    >
      {children}
    </Box>
  );
}

function OutgoingMessage({ children, color }) {
  return (
    <Box
      sx={{
        alignSelf: "flex-end",
        maxWidth: "78%",
        px: "12px",
        py: "8px",
        borderRadius: "16px 1px 16px 16px",
        background: color,
        color: COLORS.white,
        fontFamily: FONT.family,
        fontSize: "14px",
        lineHeight: "20px",
      }}
    >
      {children}
    </Box>
  );
}

function MessageTooltip() {
  return (
    <Box
      sx={{
        position: "relative",
        lineHeight: 0,
        mb: "-4px",
        "& svg": { display: "block" },
      }}
    >
      <MessageTooltipIcon />
      <Typography
        sx={{
          position: "absolute",
          top: 11,
          left: 0,
          right: 0,
          textAlign: "center",
          color: COLORS.white,
          fontSize: "11px",
          fontFamily: FONT.family,
          lineHeight: "normal",
        }}
      >
        03:53:11 pm
      </Typography>
    </Box>
  );
}

function InstallPreview({ settings }) {
  const { primaryColor, position } = settings;

  return (
    <Box sx={{ width: 400 }}>
      <Box
        sx={{
          width: 400,
          height: 619,
          borderRadius: "8px",
          background: COLORS.white,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          boxShadow: "0 8px 24px rgba(6, 21, 34, 0.12)",
        }}
      >
        <Box
          sx={{
            height: 64,
            px: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: primaryColor,
            borderRadius: "8px 8px 0 0",
            flexShrink: 0,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                backgroundImage: `url(${AGENT_AVATAR})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundColor: "rgba(255,255,255,0.25)",
              }}
            />
            <Typography sx={{ color: COLORS.white, fontSize: "16px", fontWeight: 600, lineHeight: "20px" }}>
              Eleanor Pena
            </Typography>
          </Box>
          <Typography sx={{ color: COLORS.white, fontSize: "20px", lineHeight: 1, letterSpacing: "2px" }}>
            ⋯
          </Typography>
        </Box>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            p: "16px",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            overflow: "hidden",
          }}
        >
          <Box sx={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <Avatar />
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <IncomingMessage>Hello there!</IncomingMessage>
              <Box sx={{ mt: "6px" }}>
                <IncomingMessage>{LONG_REPLY}</IncomingMessage>
              </Box>
              <Timestamp>01:34 pm</Timestamp>
            </Box>
          </Box>

          <Typography
            sx={{
              textAlign: "center",
              color: COLORS.textSecondary,
              fontSize: "12px",
              fontFamily: FONT.family,
              my: "4px",
            }}
          >
            You have closed the chat.
          </Typography>

          <Box sx={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
            <Avatar />
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
              <IncomingMessage>Hello there!</IncomingMessage>
              <Timestamp>01:34 pm</Timestamp>
            </Box>
          </Box>

          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 0 }}>
            <MessageTooltip />
            <OutgoingMessage color={primaryColor}>Hello there!</OutgoingMessage>
            <Box sx={{ mt: "6px", display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
              <OutgoingMessage color={primaryColor}>{LONG_REPLY}</OutgoingMessage>
              <Timestamp align="right">01:34 pm</Timestamp>
            </Box>
          </Box>
          <Box sx={{ mt: "auto", display: "flex", justifyContent: "center", pt: "8px" }}>
            <PoweredByTrustChatIcon />
          </Box>
        </Box>

        <WidgetInputBar placeholder="Type your massage ..." />
      </Box>

      <WidgetFab color={primaryColor} position={position} variant="chevron" />
    </Box>
  );
}

export default React.memo(InstallPreview);
